import { ReducerActionRotaSP } from 'store/modules/types';

import { ConsultarParametrosLocalidadeV2Request, Types } from './types';

export function consultarParametrosLocalidadeV2Request(
	token: string,
	data: ConsultarParametrosLocalidadeV2Request,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PARAMETROS_LOCALIDADE_V2,
		token,
		payload: {
			sigla: data.sigla,
			idOrgao: data.idOrgao,
		},
	};
}
export function consultarParametrosLocalidadeV2Success(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PARAMETROS_LOCALIDADE_V2_SUCCESS,
		payload,
	};
}
export function consultarParametrosLocalidadeV2Failure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PARAMETROS_LOCALIDADE_V2_FAILURE,
		payload: null,
	};
}
export function consultarParametrosLocalidadeV2Clear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PARAMETROS_LOCALIDADE_V2_CLEAR,
		payload: null,
	};
}
